/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, Input, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

export interface DataSource {
  key: string;
  value: Properties;
}

export interface Properties {
  name: string;
  description?: string;
}

export interface CustomModel {
  key: string;
  selected: boolean;
}

@Component({
  selector: 'formly-matrix-field',
  templateUrl: './formly-matrix-field.component.html',
  styleUrls: ['./formly-matrix-field.component.scss'],
})
export class FormlyMatrixFieldComponent extends FieldType implements OnInit {
  @Input() label: string;
  @Input() name: string;

  dataSourceX: DataSource[];
  dataSourceY: DataSource[];

  values: CustomModel[] = [];

  count;

  reload = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.count = 0;
    this.label = this.to.label;
    this.name = this.key.toString();
    this.dataSourceX = JSON.parse(this.to.dataSourceX) as DataSource[];
    this.dataSourceY = JSON.parse(this.to.dataSourceY) as DataSource[];

    if (this.to.required) {
      this.updateValidation();
    }

    this.dataSourceY.forEach((y) => {
      this.dataSourceX.forEach((x) => {
        this.values.push({
          key: `${y.key}|${x.key}`,
          selected: false,
        } as CustomModel);
      });
    });
  }

  onCheckboxChange(y: string, x: string, { detail }) {
    const key = `${y}|${x}`;
    if (this.values.filter((x) => x.key == key).length > 0) {
      this.values.filter((x) => x.key == key)[0].selected = detail.isChecked;
    } else {
      this.values.push({
        key: key,
        selected: detail.isChecked,
      } as CustomModel);
    }

    this.field.formControl.patchValue(JSON.stringify(this.values));

    if (this.to.required) {
      this.updateCounter(detail.isChecked);
      this.updateValidation();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCheckboxAllRowChange(yKey: string, e: any) {
    this.values
      .filter((x) => x.key.startsWith(yKey + '|'))
      .forEach((item) => (item.selected = e.detail.isChecked));

    this.reload = !this.reload;
  }

  updateCounter(isChecked: boolean) {
    this.count = isChecked
      ? (this.count = this.count + 1)
      : (this.count = this.count - 1);
  }

  updateValidation() {
    if (this.count === 0) {
      this.field.formControl.setErrors({ isNotValid: true });
    } else {
      this.field.formControl.setErrors(null);
    }
  }

  removePossibleHtmlTags(text: string) {
    const regex = /(<([^>]+)>)/gi;

    return text.replace(regex, '');
  }
}
